import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CoinPlusIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M7.6199 5.48C10.5028 5.48 12.8399 4.70098 12.8399 3.74C12.8399 2.77902 10.5028 2 7.6199 2C4.73698 2 2.3999 2.77902 2.3999 3.74C2.3999 4.70098 4.73698 5.48 7.6199 5.48Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M12.8399 7.80005C12.8399 8.76285 10.5199 9.54005 7.6199 9.54005C4.7199 9.54005 2.3999 8.76285 2.3999 7.80005"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M2.3999 3.73999V11.86C2.3999 12.8228 4.7199 13.6 7.6199 13.6C8.32215 13.6 8.43038 13.5544 9.0399 13.4717M12.8399 3.73999V9.19995"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M12.8398 11.2V14.8"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M11.04 13H14.64"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
